<template>
  <div class="card margin-bottom-m">
    <ul>
      <li v-for="item in foods" v-bind:key="item.food_id">{{item.food_name}} ({{item.amount}} g.)</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MealCard',
  props: {
    foods: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../stylesheets/variables";

.card {
  border: 2px solid #000000;
  border-radius: 1em;
  padding: 1em 1em 1em 1em;
  margin: 1%;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/MealCard.vue